export const Loading = () => {
  return (
    <img
      src={process.env.REACT_APP_URL + "/images/petloader.gif"}
      alt="loading..."
      width="50"
      height="50"
    />
  );
};
